import { systemFlags } from '@/utils/flags/system'
import { getFlag } from '@/store/utils/getters'
import actions from './systemActions'

export const initialState = {
    user: undefined,
}

export const mutations = {
    CLEAN (state) {
        Object.assign(state, initialState)
    },
    SET_USER (state, user) {
        state.user = user
    },
}

export const getters = {
    isLoading: (state, g, rootState) => getFlag(rootState, systemFlags.LOADING),
}

export default {
    namespaced: true,
    state: {
        ...initialState,
    },
    actions,
    getters,
    mutations,
}
